import React, {Component} from 'react';
import { connect } from 'dva';
import { Button, Row, Col } from 'antd';
import _ from 'lodash';

const CousellingDetail  = (props) => {
  const {item} = props;
  const gender = (item.get('gender') === 'male') ? 'is-mr' : 'is-ms';
  console.info(item.toJS());
  return (
    <section className={`${gender} counselling-item`}>
      <div className="counselling-item__title">
        {item.get('title')}
      </div>
      <div className="counselling-item__school">
        <Row type="flex" justify="space-around" align="middle" gutter={8}>
          <Col span={4}>
            <img className="counselling-item__img" src={item.get('school_logo')} alt={item.get('school')}/>
          </Col>
          <Col span={20}>
            <div className="counselling-item__school_name">{item.get('school')} <span>({item.get('school_type')})</span></div>
            <div className="counselling-item__school_course">{item.get('course')}</div>
          </Col>
        </Row>
      </div>
      <div>
        {item.get('acquired_visa') &&
        <div className="counselling-item__status mb-1">
          <i className="fa fa-calendar"></i> 延長期間: <span className="counselling-item__status_meta">{item.get('term')}<span>ヶ月</span></span>
          {item.get('extend_visa') &&
          <span>トラトラで更新</span>
          }
        </div>
        }
        <div className="counselling-item__status mb-1">
          <i className="fa fa-dollar"></i> 更新時の費用: <span className="counselling-item__status_meta"><span>$</span>{item.get('cost')}</span>
          {item.get('split_payment') &&
          <span>
              分割 <span>$</span>{item.get('split_cost')}
            </span>
          }
        </div>
      </div>

      <div>
        <div className="counselling-item__desc" dangerouslySetInnerHTML={{__html: item.get('desc')}}></div>
      </div>

      <div>
        <Button className='btn btn-xs btn-primary'>この学校の詳細を見る</Button>
      </div>

      <Row>
        {item.get('acquired_visa') &&
        <Col xs={12} className="mb-2">
          <div className="">更新されたビザ</div>
          <div className="">{item.get('acquired_visa_text')}</div>
        </Col>
        }
        {item.get('monthly_tuition') &&
        <Col xs={12} className="mb-2">
          <div className="">学費月額</div>
          <div className="">
            <span>$</span>{item.get('monthly_tuition')}</div>
        </Col>
        }
        <Col xs={12} className="mb-2">
          <div className="">職業</div>
          <div className="">{item.get('occupation_text')}</div>
        </Col>
        <Col xs={12} className="mb-2">
          <div className="">英語レベル</div>
          <div className="">{item.get('english_level_text')}</div>
        </Col>
      </Row>
    </section>
  );
}

//export default CousellingDetail;
export default connect(({ meta, school }) => ({
  meta, school
}))(CousellingDetail);



// WEBPACK FOOTER //
// ./src/pages/school/components/CounsellingDetail.js